export default __webpack_public_path__ + "63c9b977aac2e02f288a3a6e7b6120ab.svg";